import { Component, OnInit, Input, Output, EventEmitter, ViewRef, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'simple-modal',
  templateUrl: './simple-modal.component.html',
  styleUrls: ['./simple-modal.component.scss']
})
export class SimpleModalComponent implements OnInit {

  @ViewChild('thisModal') public thisModal: ModalDirective;
  
  @Input() classes: string = '';
  @Input() heading: string = '';
  
  @Input() okButtonLabel: string = 'Okay';
  @Input() cancelButtonLabel: string = 'Cancel';

  @Input() okButtonClasses: string = 'btn-primary';
  @Input() cancelButtonClasses: string = 'btn-flat';
  
  @Input() showOkButton: boolean = true;
  @Input() showCancelButton: boolean = true;

  @Input() okCallback: (arg?: any) => void;
  @Input() cancelCallback: (arg?: any) => void;

  @Input() ignoreBackdropClick: boolean = true;

  @Input() passData: any;

  @Input() set visible(isVisible) {
    setTimeout(() => {
      if (isVisible) this.thisModal.show();
      else this.thisModal.hide();
    }, 0);
  }

  @Output() onClose = new EventEmitter<any>();
  @Output() onOkay = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  hide() {
    this.thisModal.hide();
  }

  close() {
    this.hide();
    this.onClose.emit(this.passData);
  }

  ok() {
    this.hide();

    if (this.okCallback) this.okCallback(this.passData);
    this.onOkay.emit(this.passData);
  }

  cancel() {
    this.hide();

    if (this.cancelCallback) this.cancelCallback(this.passData);
    this.onCancel.emit(this.passData);
  }

}
